module.exports = __webpack_public_path__ + "img/178.d04e4a8d.jpg";